/** The kinds of institution the platform can hold. */
export const ORG_KINDS = ['shul', 'school', 'chesed', 'group'] as const

export type OrgKind = (typeof ORG_KINDS)[number]
